import React from "react";
import "./SponsorsContent.css";
import Floaticons from "./Floaticons";
import SponsorTeam from "../data/sponsorsteam.json";

const SponsorsContent = () => {
    return (
        <>
            <div className="sponsors-container">
                <div className="main-banner">
                    <img src="images/Sponsors/Banner.png" alt="sponsors Banner" className="banner-img" />
                    <img src="images/Home/banner-strip.png" alt="strip" className="strip-img" />
                    <div className="announcemnt-box">
                        <h1 class="visually-hidden">Sponsors</h1>
                        <p>
                            <img src="images/Home/speaker.png" alt="speaker" className="speaker-img" />
                            <marquee
                                width="92%"
                                direction="left"
                                style={{ display: "inline-block", verticalAlign: "middle" }}
                            >
                                {" "}
                                <b>Come Join Us</b> on an exhilarating learning Journey on ABC University
                                Platform!!!
                            </marquee>
                        </p>
                    </div>
                    <Floaticons />
                </div>
                <div className="team-section">
                    <div className="team-header" role="heading" aria-level="2">
                        Leadership Team
                    </div>
                    <div className="team-wrapper">
                        <div className="team-box">
                            {SponsorTeam.map((item) =>
                                item.leadershipTeam.map((team) => {
                                    return (
                                        <>
                                            <div className="team-row">
                                                <img
                                                    src={team["team-img"]}
                                                    alt={team["team-name"] + " Profile Image"}
                                                    className="team-img"
                                                />
                                                <h4 role="heading" aria-level="3">
                                                    {team["team-name"]}
                                                </h4>
                                                <p>{team["team-designation"]}</p>
                                                <div className="team-contact-icons">
                                                    <a href={team["enterprise"]}>
                                                        <img
                                                            src="images/Sponsors/EmailIconColored.png"
                                                            alt="email-icon"
                                                            className="email"
                                                        />
                                                    </a>
                                                    <a href={team["profile-link"]} target="_blank">
                                                        <img
                                                            src="images/Sponsors/ProfileIconColored.png"
                                                            alt="avatar-icon"
                                                            className="avatar"
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        </>
                                    );
                                })
                            )}
                        </div>
                    </div>
                </div>
                <div className="coreteam-section">
                    <div className="coreteam-header" role="heading" aria-level="2">
                        Core Team
                    </div>
                    <div className="coreteam-wrapper">
                        <div className="coreteam-box">
                            {SponsorTeam.map((item) =>
                                item.coreTeam.map((team) => {
                                    return (
                                        <>
                                            <div className="coreteam-row">
                                                <img src={team["team-img"]} alt="Team" className="coreteam-img" />
                                                <h4 role="heading" aria-level="3">
                                                    {team["team-name"]}
                                                </h4>
                                                <p>{team["team-designation"]}</p>
                                                <div className="coreteam-contact-icons">
                                                    <a href={team["enterprise"]}>
                                                        <img
                                                            src="images/Sponsors/EmailIconColored.png"
                                                            alt="email-icon"
                                                            className="email"
                                                        />
                                                    </a>
                                                    <a href={team["profile-link"]} target="_blank">
                                                        <img
                                                            src="images/Sponsors/ProfileIconColored.png"
                                                            alt="avatar-icon"
                                                            className="avatar"
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        </>
                                    );
                                })
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SponsorsContent;
